import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import TabLenguaje from './TabLenguaje';
import CodeContent from './CodeContent';
import Tabla from './Tabla';
import EndpointContent from './EndpointContent';
import TablaTipoComprobante from './TablaTipoComprobante';
import TablaDocs from './TablaDocs';

function createData(
  campo,
  Tipo,
  valorEjemplo,
  Descripcion
) {
  return { campo, Tipo, valorEjemplo, Descripcion };
}
function TablaDoc(
  Descripcion,
 Detalles
) {
return { Descripcion,Detalles };
}
const Anulacion = () => {
  const [t] = useTranslation('global');

  const rows = [
    createData('ID', "Number", "123", t('content.anulacion.descripcionid')),
    createData('TipoDocumentoCodigo', "String", "01", t('content.anulacion.descripcionTipoDoc')),
    createData('Serie', "String", "F001", t('content.anulacion.descripcionSerie')),
    createData('Correlativo', "Number", "56", t('content.anulacion.descripcionCorrelativo')),
    createData('FechaEmision', "String", "30/05/2022", t('content.anulacion.descripcionFechaEmision')),
    createData('MotivoBaja', "String", "Error de monto", t('content.anulacion.descripcionMotivoBaja')),
    createData('ListaDetalles', "Array", "[{ComprobanteDetalle1},{ComprobanteDetalle2}]", t('content.anulacion.descripcionDetalles')),
    createData('ListaMovimientos', "Array", "[{ MovimientoCuenta1},{MovimientoCuenta2}]", t('content.anulacion.descripcionMovimientos'))
  ];
  const RowsEjemploNotaCredito = [
    TablaDoc(t('content.anulacion.ejemplo1'),  '/content/EjemplosNotaCreditos/EMISION DE NOTA DE CREDITO DE FACTURA CON ANULACION DE LA OPERACIÓN.json'),
    TablaDoc(t('content.anulacion.ejemplo2'),  '/content/EjemplosNotaCreditos/EMISION DE NOTA DE CREDITO DE FACTURA CON DEVOLUCION POR ITEM.json'),
    TablaDoc(t('content.anulacion.ejemplo3'),  '/content/EjemplosNotaCreditos/EMISION DE NOTA DE CREDITO DE BOLETA CON ANULACION DE LA OPERACIÓN.json'),
    TablaDoc(t('content.anulacion.ejemplo4'),  '/content/EjemplosNotaCreditos/EMISION DE NOTA DE CREDITO DE BOLETA CON DEVOLUCION POR ITEM.json')]
  

  const cCurl =
    `  
      curl --location --request PUT 'https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1'
      --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
      --header 'Content-Type: application/json'
      --data '{ ... }'
        `;
  const csRS =
    `   
      var options = new RestClientOptions("")
      {
        MaxTimeout = -1,
      };
      var client = new RestClient(options);
      var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1", Method.Put);
      request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
      request.AddHeader("Content-Type", "application/json");
      var body = @"{ ... }";
      request.AddStringBody(body, DataFormat.Json);
      RestResponse response = await client.ExecuteAsync(request);
      Console.WriteLine(response.Content);
          `;
  const javaOK =
    `        
      OkHttpClient client = new OkHttpClient().newBuilder()
        .build();
      MediaType mediaType = MediaType.parse("application/json");
      RequestBody body = RequestBody.create(mediaType, "{ ... }");
      Request request = new Request.Builder()
        .url("https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1")
        .method("PUT", body)
        .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
        .addHeader("Content-Type", "application/json")
        .build();
      Response response = client.newCall(request).execute();
            `
    ;
  const phpHC =
    `
      <?php
      require_once 'HTTP/Request2.php';
      $request = new HTTP_Request2();
      $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1');
      $request->setMethod(HTTP_Request2::METHOD_PUT);
      $request->setConfig(array(
        'follow_redirects' => TRUE
      ));
      $request->setHeader(array(
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
        'Content-Type' => 'application/json'
      ));
      $request->setBody('{ ... }');
      try {
        $response = $request->send();
        if ($response->getStatus() == 200) {
          echo $response->getBody();
        }
        else {
          echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
          $response->getReasonPhrase();
        }
      }
      catch(HTTP_Request2_Exception $e) {
        echo 'Error: ' . $e->getMessage();
      }
    `;
  const csHTC =
    `         
      var client = new HttpClient();
      var request = new HttpRequestMessage(HttpMethod.Put, "https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1");
      request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
      var content = new StringContent("{ ... }", null, "application/json");
      request.Content = content;
      var response = await client.SendAsync(request);
      response.EnsureSuccessStatusCode();
      Console.WriteLine(await response.Content.ReadAsStringAsync());
      `;
  const javaUNI =
    `        
      Unirest.setTimeouts(0, 0);
      HttpResponse<String> response = Unirest.put("https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1")
        .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
        .header("Content-Type", "application/json")
        .body("{}")
        .asString();
    
          `;
  const phpGZ =
    `     
      <?php
      $client = new Client();
      $headers = [
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
        'Content-Type' => 'application/json'
      ];
      $body = '{}';
      $request = new Request('PUT', 'https://wsventas-exp.rapifac.com/v0/comprobantes/anular?IncluirCDR=1', $headers, $body);
      $res = $client->sendAsync($request)->wait();
      echo $res->getBody();
      `;


      
  const JsonFactura = 
  `
  {
    "ID": 205100,
    "DocumentoID": "F001-1",
    "TipoDocumentoCodigo": "01",
    "Serie": "F001",
    "Correlativo": 1,
    "FechaEmision": "30/01/2024",
    "Sucursal": 3691,
    "MotivoBaja": "error al emitir",
    "ListaDetalles": [
        {
            "ID": 241232,
            "Item": 1,
            "ComprobanteID": 205100,
            "TipoDocumentoCodigo": "03",
            "Serie": "F001",
            "Correlativo": 1,
            "UnidadMedidaCodigo": "NIU",
            "Cantidad": 2,
            "ProductoCodigo": "Prod00270",
            "ProductoCodigoCliente": "Prod00270"
        }
    ],
    "ListaMovimientos": [
        {
            "CuentaNumero": "13131313",
            "Observacion": "sfdfsdf",
            "NumeroOperacion": "",
            "TipoDocumentoCodigo": "01",
            "Serie": "F001",
            "Correlativo": 1,
            "Usuario": "13131313",
            "Pago": 9.999999,
            "PlazoDias": 5,
            "Condicion": "Contado"
        }
    ]
}
  `;
  const JsonBoleta = 
  `
  {
    "ID": 205101,
    "DocumentoID": "B001-1",
    "TipoDocumentoCodigo": "03",
    "Serie": "B001",
    "Correlativo": 1,
    "FechaEmision": "30/01/2024",
    "Sucursal": 3691,
    "MotivoBaja": "error al emitir",
    "ListaDetalles": [
        {
            "ID": 241232,
            "Item": 1,
            "ComprobanteID": 205100,
            "TipoDocumentoCodigo": "03",
            "Serie": "B001",
            "Correlativo": 1,
            "UnidadMedidaCodigo": "NIU",
            "Cantidad": 2,
            "ProductoCodigo": "Prod00270",
            "ProductoCodigoCliente": "Prod00270"
        }
    ],
    "ListaMovimientos": [
        {
            "CuentaNumero": "13131313",
            "Observacion": "sfdfsdf",
            "NumeroOperacion": "",
            "TipoDocumentoCodigo": "01",
            "Serie": "B001",
            "Correlativo": 1,
            "Usuario": "13131313",
            "Pago": 9.999999,
            "PlazoDias": 5,
            "Condicion": "Contado"
        }
    ]
}
  `;
  const JsonNotaCredito = 
  `
  {
    "ID": 205102,
    "DocumentoID": "FC01-1",
    "TipoDocumentoCodigo": "07",
    "Serie": "FC01",
    "Correlativo": 1,
    "FechaEmision": "30/01/2024",
    "Sucursal": 3691,
    "MotivoBaja": "error al emitir",
    "ListaDetalles": [
        {
            "ID": 241232,
            "Item": 1,
            "ComprobanteID": 205100,
            "TipoDocumentoCodigo": "03",
            "Serie": "FC01",
            "Correlativo": 1,
            "UnidadMedidaCodigo": "NIU",
            "Cantidad": 2,
            "ProductoCodigo": "Prod00270",
            "ProductoCodigoCliente": "Prod00270"
        }
    ],
    "ListaMovimientos": [
        {
            "CuentaNumero": "13131313",
            "Observacion": "sfdfsdf",
            "NumeroOperacion": "",
            "TipoDocumentoCodigo": "01",
            "Serie": "FC01",
            "Correlativo": 1,
            "Usuario": "13131313",
            "Pago": 9.999999,
            "PlazoDias": 5,
            "Condicion": "Contado"
        }
    ]
}
  `;
  const JsonNotaDebito = 
  `
  {
    "ID": 205103,
    "DocumentoID": "FD01-1",
    "TipoDocumentoCodigo": "08",
    "Serie": "FD01",
    "Correlativo": 1,
    "FechaEmision": "30/01/2024",
    "Sucursal": 3691,
    "MotivoBaja": "error al emitir",
    "ListaDetalles": [
        {
            "ID": 241232,
            "Item": 1,
            "ComprobanteID": 205100,
            "TipoDocumentoCodigo": "03",
            "Serie": "FD01",
            "Correlativo": 1,
            "UnidadMedidaCodigo": "NIU",
            "Cantidad": 2,
            "ProductoCodigo": "Prod00270",
            "ProductoCodigoCliente": "Prod00270"
        }
    ],
    "ListaMovimientos": [
        {
            "CuentaNumero": "13131313",
            "Observacion": "sfdfsdf",
            "NumeroOperacion": "",
            "TipoDocumentoCodigo": "01",
            "Serie": "FD01",
            "Correlativo": 1,
            "Usuario": "13131313",
            "Pago": 9.999999,
            "PlazoDias": 5,
            "Condicion": "Contado"
        }
    ]
}
  `;
  // para la anulacion nota de credito

  const cCurlNotaCredito =
    `  
            curl --location 'https://wsventas-exp.rapifac.com/v0/comprobantes' 
            --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...'  //se agrega bearer y el token obtenido en la autentificación 
            --header 'Content-Type: application/json' 
            --data '{ /* Datos del comprobante */ }'
        `;
  const csRSNotaCredito =
        `   
            var options = new RestClientOptions("")
            {
             MaxTimeout = -1,
            };
            var client = new RestClient(options);
            var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobantes", Method.Post);
            request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...");
            request.AddHeader("Content-Type", "application/json");
            var body = @"{ ./* Datos del comprobante*/ }";
            request.AddStringBody(body, DataFormat.Json);
            RestResponse response = await client.ExecuteAsync(request);
            Console.WriteLine(response.Content);
          `;
  const javaOKNotaCredito =
    `        
            OkHttpClient client = new OkHttpClient().newBuilder()
             .build();
            MediaType mediaType = MediaType.parse("application/json");
            RequestBody body = RequestBody.create(mediaType, "{ /* Datos del comprobante */ }");
            Request request = new Request.Builder()
             .url("https://wsventas-exp.rapifac.com/v0/comprobantes")
             .method("POST", body)
             .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...")
             .addHeader("Content-Type", "application/json")
             .build();
            Response response = client.newCall(request).execute();
            `
    ;
  const phpHCNotaCredito =
    `
            <?php
            require_once 'HTTP/Request2.php';
            $request = new HTTP_Request2();
            $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1');
            $request->setMethod(HTTP_Request2::METHOD_POST);
            $request->setConfig(array(
            'follow_redirects' => TRUE
            ));
            $request->setHeader(array(
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD',
            '' => '',
            'Content-Type' => 'application/json'
            ));
            $request->setBody('{ /* Datos del comprobante*/ }');
            try {
            $response = $request->send();
            if ($response->getStatus() == 200) {
                echo $response->getBody();
            }
            else {
                echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
                $response->getReasonPhrase();
            }
            }
            catch(HTTP_Request2_Exception $e) {
            echo 'Error: ' . $e->getMessage();
            }
    `;
  const csHTCNotaCredito =
    `         
            var client = new HttpClient();
            var request = new HttpRequestMessage(HttpMethod.Post, "https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1");
            request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD...");
            request.Headers.Add("", "");
            var content = new StringContent("/* datos del comprobante */", null, "application/json");
            request.Content = content;
            var response = await client.SendAsync(request);
            response.EnsureSuccessStatusCode();
            Console.WriteLine(await response.Content.ReadAsStringAsync());
          
          `;
  const javaUNINotaCredito =
    `        
            Unirest.setTimeouts(0, 0);
            HttpResponse<String> response = Unirest.post("https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1")
            .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD...")
            .header("", "")
            .header("Content-Type", "application/json")
            .body("{/* datos del comprobante */}")
            .asString();
          `;
  const phpGZNotaCredito =
    `     
            <?php
            $client = new Client();
            $headers = [
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD',
            '' => '',
            'Content-Type' => 'application/json'
            ];
            $body = '{
                /*Datos del comprobante*/
            }';
            $request = new Request('POST', 'https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1', $headers, $body);
            $res = $client->sendAsync($request)->wait();
            echo $res->getBody();
          `;

  return (
    <div id='anulacion'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" id="anulacionComprobante" gutterBottom>
        {t('content.anulacion.titulo')}
      </Typography>
      <Typography variant="h5" id="anulacion" gutterBottom>
        {t('content.anulacion.subTituloGeneral')}
      </Typography>
      <Typography variant="body1" id="anulacion" gutterBottom>
        {t('content.anulacion.subTitulo')}
      </Typography>
      <EndpointContent method='PUT' path='https://wsventas-exp.rapifac.com/v0/comprobantes/anular'/>
      <TabLenguaje curl={cCurl} csRS={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} >
      </TabLenguaje>
      <br id={"anulacionObjeto"}/>
      <br/>
      <br/> 
      <Typography variant="h5" id="anulacion" gutterBottom>
        {t('content.anulacion.subtituloObjeto')}
      </Typography>
      <Typography variant="body1" id="anulacion" gutterBottom>
        {t('content.anulacion.texto')}
      </Typography>
      {/*<CodeContent code={datos} />*/}
      <TablaTipoComprobante Factura={JsonFactura} NombreFactura={t('content.factura.titulo')} Boleta={JsonBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={JsonNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={JsonNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante>
      <br id={"anulacionDescripcion"}/>
      <br/>
      <br/>
      <Typography variant="h5" id="anulacion" gutterBottom>
        {t('content.anulacion.subtituloTabla')}
      </Typography>
      <Tabla rows={rows}>
      
      </Tabla>
      <br></br>
      <br/>
      <br/>
      <Typography variant="h5" id="anulacion" gutterBottom>
        {t('content.anulacion.SubTituloAnulacionNotaCredito')}
      </Typography>
      <Typography variant="body1" id="anulacion" gutterBottom>
        {t('content.anulacion.DescripcionAnulacionNotaCredito')}
      </Typography>
      <br></br>
      <EndpointContent method='POST' path='https://wsventas-exp.rapifac.com/v0/comprobantes'/>

      <TabLenguaje  curl={cCurlNotaCredito} csRS ={csRSNotaCredito} javaOK={javaOKNotaCredito} phpRQ={phpHCNotaCredito} csHC={csHTCNotaCredito} java2UN={javaUNINotaCredito} php2GZ={phpGZNotaCredito} >
      </TabLenguaje>
      <br></br>
      <TablaDocs rows={RowsEjemploNotaCredito} />
    </div>
  );
}
export default Anulacion